import angular from 'angular';
import constants from 'app/constants';
import {
  ecatDataService,
  ecatSharedModelService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './edit-maturity-profile-dialog.controller';
import template from './edit-maturity-profile-dialog.html';

class dialogService {
  getOptions($event, { assessmentId, maturityProfile }) {
    return {
      controller,
      controllerAs: 'editMaturityProfileDialogVM',
      locals: {
        assessmentId,
        maturityProfile,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.ecat.editMaturityProfileDialog', [
  alerts,
  constants,
  ecatDataService,
  ecatSharedModelService,
  loaderService,
  ssDialogService,
])
  .service('editMaturityProfileDialog', dialogService)
  .name;
